import { useUser } from 'hooks'
import { StatsProvider, useStats } from './lib/ctx/stats'
import { ReaderSummaryProvider } from './lib/ctx/reader_summary'
import { CompProps } from '@fable/types'
import { useLoadStats, useStatsAnalytics } from './lib/hooks'

const Providers = ({ children }: CompProps) => {
  const { user, loading } = useUser()
  const [stats, isSelfView] = useStats((s) => [s.stats, s.isSelfView])

  useLoadStats()
  useStatsAnalytics()

  if (loading) return null

  return (
    <ReaderSummaryProvider
      stats={stats}
      isSelfView={isSelfView}
      isUserOptedIn={user?.stats_summary_opt_in}
    >
      {children}
    </ReaderSummaryProvider>
  )
}

export const StatsProviders = ({ children, ...props }: CompProps) => (
  <StatsProvider {...props}>
    <Providers>{children}</Providers>
  </StatsProvider>
)
